import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input } from 'reactstrap';

class RenderInputForFieldComponent extends Component {
  render() {
    const {
      input,
      label,
      iconName,
      iconType,
      caption,
      inputCaption,
      stackedlabel = true,
      meta: { error },
      meta,
      itemProps,
      inputProps,
      required,
      className = '',
    } = this.props;

    let { labelClassName = '' } = this.props;

    let inputClassName = 'width-100-percent';
    let formGroupClassName = itemProps.row ? 'flex-row' : stackedlabel ? 'stacked' : 'not-stacked';

    if (itemProps.row) {
      labelClassName += ' col-xl-3 col-form-label';
      inputClassName = 'col-xl-9';
    }

    if (inputCaption === undefined || input.type === 'textarea') {
      formGroupClassName += ' centered';
    }

    const showLabel = () => {
      if (label && label.length) {
        return (
          <label className={labelClassName}>
            {required && <span className="required-field">*</span>}
            {label}
            {caption !== undefined && caption.length ? (
              <div className="caption">{caption}</div>
            ) : null}
          </label>
        );
      }
      return null;
    };
    const showError = () => null;
    const showIcon = () =>
      iconName !== undefined && iconName.length ? (
        <em className={iconName} type={iconType} />
      ) : null;

    return stackedlabel ? (
      <FormGroup {...itemProps} className={formGroupClassName}>
        {showLabel()}
        {showIcon()}
        <Input {...input} {...inputProps} />
        {inputCaption !== undefined ? (
          <div className="input-caption caption">{inputCaption}</div>
        ) : null}
        {showError()}
      </FormGroup>
    ) : (
      <FormGroup {...itemProps} className={formGroupClassName}>
        {showLabel()}
        <div className={`${inputClassName} ${className}`}>
          {showIcon()}
          <Input {...input} {...inputProps} />
          {inputCaption !== undefined ? (
            <div className="input-caption caption">{inputCaption}</div>
          ) : null}
        </div>
        {showError()}
      </FormGroup>
    );
  }
}

RenderInputForFieldComponent.propTypes = {
  input: PropTypes.shape({
    checked: PropTypes.bool,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
    type: PropTypes.string,
  }),
  label: PropTypes.string,
  stackedlabel: PropTypes.bool,
  iconName: PropTypes.string,
  caption: PropTypes.string,
  inputCaption: PropTypes.string,
  iconType: PropTypes.string,
  refField: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    autofilled: PropTypes.bool,
    asyncValidating: PropTypes.bool,
    dirty: PropTypes.bool,
    dispatch: PropTypes.func,
    error: PropTypes.string,
    form: PropTypes.string,
    initial: PropTypes.any,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    submitFailed: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool,
    warning: PropTypes.string,
  }),
  children: PropTypes.instanceOf(Array),
  itemProps: PropTypes.shape({
    floatingLabel: PropTypes.bool,
    row: PropTypes.bool,
    last: PropTypes.bool,
  }),
  inputProps: PropTypes.shape({
    multiline: PropTypes.bool,
    rowSpan: PropTypes.number,
  }),
};

export default forwardRef((props, ref) => (
  <RenderInputForFieldComponent innerRef={ref} {...props} />
));
